<template>
  <div class="team-container">
	  <div class="team-header reveal" id="team">
		  <h1>Our Team</h1>
	  </div>
	  <div class="team">
		  <div class="teamMember reveal" id="team" v-for="member in team" v-bind:key="member">
			  <TeamMemberComponent v-bind:name="member.name" v-bind:title="member.title" v-bind:img="member.img" v-bind:url="member.url"/>
		</div>
	 </div>
  </div>
</template>

<script>
import TeamMemberComponent from './TeamMember.vue';
import ScrollReveal from 'scrollreveal';


export default {
  name: 'Team',
  components: {
	  TeamMemberComponent,
  },
  data: () => ({ 
	  team: [
		  { name: 'Brandon Hill', title: 'CEO', img: require('@/assets/images/team/brandon.jpg'), url: 'https://www.linkedin.com/in/bhill93/' },
		  { name: 'Elizabeth Davis', title: 'CTO', img: require('@/assets/images/team/liz.jpg'), url: 'https://www.linkedin.com/in/elizabethsdavis/' },
		  { name: 'Tre Kirkman', title: 'CPO', img: require('@/assets/images/team/tre.jpg'), url: 'https://www.linkedin.com/in/trekirkman/' },
		  { name: 'Sam Hinshelwood', title: 'Lead Engineer', img: require('@/assets/images/team/sam.jpg'), url: 'https://www.linkedin.com/in/samhinsh/' },
	]
  }),
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

@mixin breakpoint1 { @media only screen and (min-width: 0px) { @content; } }
@mixin breakpoint2 { @media only screen and (min-width: 750px) { @content; } }
@mixin breakpoint3 { @media only screen and (min-width: 1024px) { @content; } }




.team-container {
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	min-height: 80vh;
}

.team {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
}

h1 {
    text-transform: uppercase;
    letter-spacing: 0.1em;
	font-family: 'Mont-Heavy';
	font-size: calc(1rem + 4vw);
}


@include breakpoint1 {
	.team-container {
		padding: 2em;
	}

	.team {
		flex-direction: column;
	}

	.teamMember {
		width: 100%;
		padding: 1.5em 0;
	}

	h1 {
        text-align: left;
	}
}


@include breakpoint2 {

	.team-container {
		padding: 2em 3em;
	}

	.team {
		flex-direction: row;
	}

	.teamMember {
		width: 20%;
	}

	h1 {
        text-align: center;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/Team/Team.vue